var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PhotoSwipe',_vm._b({staticClass:"kpb-gallery",attrs:{"data-kpb-variant":_vm.variant,"wrapper":_vm.layoutComponent,"data":_vm.contentComp,"child-class":"kpb-gallery__item"}},'PhotoSwipe',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }